// import 'url:./pullQuote.scss';

export const init = () => {
  console.log('pullQuote');
};

export default init;
